import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Dimmer, Header, Loader } from 'semantic-ui-react';
import NoAccounts from './NoAccounts';
import './bankAccounts.css';
import { openModal } from '../modals/modalActions';
import { getBanks, selectAccount } from './accountActions';
import Account from './Account';
import config from '../../config';

const allowedBankAccountPerUser = config.bankAccountLimit;

// Redux state
const mapState = state => ({
  auth: state.auth,
  async: state.async,
  bank: state.bank
});

// Redux actions
const actions = {
  getBanks,
  openModal,
  selectAccount
};
class BankAccountsContainer extends Component {
  static propTypes = {
    async: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    bank: PropTypes.object.isRequired,
    getBanks: PropTypes.func.isRequired,
    openModal: PropTypes.func.isRequired,
    selectAccount: PropTypes.func.isRequired
  };

  addAccount = () => {
    const { openModal } = this.props;
    if (openModal && typeof openModal === 'function') {
      openModal('AddBankAccountModal');
    }
  };

  selectAccount = account => {
    this.props.selectAccount(account);
  };

  render() {
    const { async, bank, inlineLoad, openModal } = this.props;

    let content = (
      <NoAccounts message="You don't have any bank accounts yet." />
    );

    const bankData = bank && bank.get && bank.get.data;
    const bankDataIsArr = bankData && Array.isArray(bankData);

    const inlineLoader = inlineLoad ?  (
      <Dimmer
        active={async.loading}
        inverted
      >
        <Loader content="Please wait, fetching. . ." />
      </Dimmer>
    ) : null;

    if (bankDataIsArr && bankData.length > 0) {
      content = bank.get.data.map(account => {
        return (
          <Account
            account={account}
            key={account.accountToken}
            openModal={openModal}
            selectAccount={this.selectAccount}
            customClass="account"
            clickable={true}
            border={true}
          />
        );
      });
    } else if (bankData && bankData.errorMessage) {
      content = (
        <div id="feature-bank-accounts">
          <Header as="h1">Bank Accounts</Header>
          {inlineLoader}
          <NoAccounts
            message="API Error, Unable to fetch bank account(s)!"
            error
          />
        </div>
      );
    }

    const enableBtn = bankDataIsArr && bankData.length < allowedBankAccountPerUser;

    return (
      <div id="feature-bank-accounts">
        <Header as="h1">Bank Accounts</Header>
        {content}
        {inlineLoader}
        {bankDataIsArr && bankData.length > 0 && <p>You can add only {allowedBankAccountPerUser} accounts</p>}
        <Button
          icon="plus"
          content="Add account"
          onClick={this.addAccount}
          disabled={!enableBtn}
        />
      </div>
    );
  }

  componentDidMount() {
    const {
      auth: { csrfRequestIdentifier, migration },
      inlineLoad,
      getBanks,
      bank
    } = this.props;
    
    if (
      csrfRequestIdentifier &&
      migration &&
      migration.walletToken &&
      !(bank.get && bank.get.data && Array.isArray(bank.get.data))
    ) {
      getBanks(csrfRequestIdentifier, migration.walletToken, !inlineLoad);
    }
  }
}

export default connect(
  mapState,
  actions
)(BankAccountsContainer);
